/**
 * Tom de cada etiqueta do ranking (refino final, 23/09/2026). O nome e o
 * ícone vêm de `@nv/core` (`RANKING_TITLE_LABELS`, `RANKING_CATEGORY_LABELS`);
 * aqui só a cor da pílula — decisão visual, por isso fica no cliente.
 */
import type { RankingCategory, RankingTitle } from '@nv/core';
import type { LabelTone } from '@nv/tokens';

export const TOM_DO_TITULO: Record<RankingTitle, LabelTone> = {
  fotografo: 'lilas',
  casa_nas_costas: 'teal',
  mala_pronta: 'verde',
  guia_turistico: 'azul',
  pergunta_tudo: 'ambar',
  eleitor_assiduo: 'rosa',
  organizador: 'teal',
  pontual: 'ambar',
  tesoureiro: 'coral',
  megafone: 'tinta',
};

export const TOM_DA_CATEGORIA: Record<RankingCategory, LabelTone> = {
  alimentacao: 'coral',
  transporte: 'teal',
  hospedagem: 'ambar',
  ingressos: 'lilas',
  compras: 'rosa',
  outros: 'azul',
};
